import { render, staticRenderFns } from "./ClassifyAccountAttributes.vue?vue&type=template&id=9b3a01a6&scoped=true"
import script from "./ClassifyAccountAttributes.vue?vue&type=script&lang=js"
export * from "./ClassifyAccountAttributes.vue?vue&type=script&lang=js"
import style0 from "./ClassifyAccountAttributes.vue?vue&type=style&index=0&id=9b3a01a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3a01a6",
  null
  
)

export default component.exports